SET_USER_VIDEO_PROCESSING